import { render } from "./AppTopBarNew.vue?vue&type=template&id=07b2f83b&scoped=true"
import script from "./AppTopBarNew.vue?vue&type=script&lang=js"
export * from "./AppTopBarNew.vue?vue&type=script&lang=js"

import "./AppTopBarNew.vue?vue&type=style&index=0&id=07b2f83b&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07b2f83b"]])

export default __exports__